import { createFileRoute } from '@tanstack/react-router'

import { AchReturnsScreen } from './-components/ach-returns-screen.tsx'

export const Route = createFileRoute('/ach/returns')({
  component: AchReturnsScreen
})
